/**
 * PopularSlider.js — near-4-up swipeable slider, no arrows or dots
 */
import Swiper from 'swiper';

export default class PopularSlider {
  constructor(selector = '.popular-slider') {
    this.el = document.querySelector(selector);
    if (!this.el) return;

    this.swiper = new Swiper(this.el, {
      slidesPerView: 1.25,
      spaceBetween: 16,
      breakpoints: {
        640:  { slidesPerView: 1.25, spaceBetween: 20 },
        1024: { slidesPerView: 2.25, spaceBetween: 20 },
        1280: { slidesPerView: 3.25, spaceBetween: 20 },
      },
    });
  }
}

